import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfiguracoes, fetchRecuperarAcesso } from '../../api/endpoints';
import { getTotem } from '../../api/apiFactory';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, fetchLogin, fetchLoginAnonimo } from '../../app/slices/loginSlice';
import {
  abrirModalAnonimo,
  abrirModalLogin, abrirModalTotemLogin, fecharModalEscolhaLoginTotem, fecharModalLogin, fecharModalTotemLogin, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria } from '../../app/slices/secretariasSlice';
import {
  ContainerJanela, Divisor, FormFooter, Linha,
} from '../../styles/base';
import {
  cnpj, cpf, email, isCNPJ, tel,
} from '../../util/mascaras';
import Botao from '../Botao/Botao';
import { AbaContainer } from '../Botao/BotaoEstilo';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import {
  Aviso, JanelaLogin, JanelaLoginTotem, LinkEmail, TituloModal,
} from './ModalEscolhaLoginTotemEstilo';

const ModalEscolhaLoginTotem = () => {
  const [carregando, setCarregando] = useState(false);

  const dispatch = useDispatch();
  const alert = useAlert();
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);

  const [verificarMudancaAnominoCidade, setVerificarMudancaAnominoCidade] = useState();
  fetchConfiguracoes().then((response) => setVerificarMudancaAnominoCidade(response));

  const entrarAnonimo = async () => {
    if (dadosModal.origem === 'manifestacao') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'o',
      }));
    }
    if (dadosModal.origem === 'sic') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 's',
      }));
    }
    if (dadosModal.origem === 'zeladoria') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'z',
      }));
    }

    if (dadosModal.origem === 'manifestacao' || dadosModal.origem === 'sic' || dadosModal.origem === 'zeladoria') {
      dispatch(definirSecretaria({
        idSecretaria: dadosModal.secretaria.idSecretaria,
        nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
        corSecretaria: dadosModal.secretaria.corSecretaria,
      }));
    }

    if (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N') {
      dispatch(abrirModalAnonimo());
    }
    dispatch(fecharModalEscolhaLoginTotem());
  };

  // const entrarCadastrado = async (event) => {
  //   event.preventDefault();
  //   setCarregando(true);
  //   const resposta = await dispatch(fetchLogin({
  //     username: values.Usuario,
  //     password: values.Senha,
  //   }));

  //   if (!values.Usuario) {
  //     dispatch(desfazerConexao());
  //     setCarregando(false);
  //     return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
  //   }

  //   if (emailLoginAtivo && !values.Usuario.includes('@')) {
  //     dispatch(desfazerConexao());
  //     setCarregando(false);
  //     return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
  //   }

  //   if (resposta.payload === 'Credencial errada.') {
  //     dispatch(desfazerConexao());
  //     setCarregando(false);
  //     return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
  //   }

  //   setCarregando(false);

  //   if (dadosModal.origem === 'manifestacao' || dadosModal.origem === 'sic') {
  //     dispatch(definirSecretaria({
  //       idSecretaria: dadosModal.secretaria.idSecretaria,
  //       nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
  //       corSecretaria: dadosModal.secretaria.corSecretaria,
  //     }));
  //   }

  //   return dispatch(fecharModalLogin());
  // };

  return (
    <ContainerJanela>
      <JanelaLogin>
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fecharTotem
            onClick={() => dispatch(fecharModalEscolhaLoginTotem())}
          />
        </Linha>

        <TituloModal totem>Escolha a opção desejada:</TituloModal>

        <Divisor />

        <div style={{ display: 'flex', gap: 40 }}>
          <Botao
            label="Entrar"
            routerTotem
            onClick={() => { dispatch(fecharModalEscolhaLoginTotem()); dispatch(abrirModalTotemLogin()); }}
            style={{
              width: 250, flex: 1, padding: '40px 25px', fontSize: 25, backgroundColor: '#13a713',
            }}
          />

          <Botao
            label="Cadastre-se"
            routerTotem
            to="/conta"
            onClick={() => dispatch(fecharModalEscolhaLoginTotem())}
            style={{
              width: 250, flex: 1, padding: '40px 25px', fontSize: 25,
            }}
          />
        </div>

        <Divisor />
        <Divisor />

        {/* {((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'S' && dadosModal.origem === 'manifestacao') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'S' && dadosModal.origem === 'sic')) && ( */}

        {((verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoOuvidoria === 'S' && dadosModal.origem === 'manifestacao') || (verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoSic === 'S' && dadosModal.origem === 'sic') || (verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoZeladoria === 'S' && dadosModal.origem === 'zeladoria')) && (
        <Botao
          label="Continuar como anônimo"
          link
          onClick={entrarAnonimo}
          style={{ fontSize: 20, paddingBottom: 10 }}
        />
        )}

      </JanelaLogin>
    </ContainerJanela>
  );
};

export default ModalEscolhaLoginTotem;
